<template>
  <main class="relative" ref="main">
    <loading
      :active.sync="loader.isLoading"
      :background-color="loader.background"
      :color="loader.color"
      :opacity="loader.opacity"
      :is-full-page="loader.fullPage"
      :loader="loader.loader"
    ></loading>

    <div class="results" v-if="results.length > 0">

      <header-results />
      <vehicle-info />

      <base-listing
        v-for="(item, index) in results[0].use"
        :class="[index === 0 ? 'mt-0' : 'mt-10']"
        :apiData="filterProducts(item, 'baseProduct')"
        :capacities="results[0].capacities"
        :title-label="results[0].label"
        :title-code="results[0].code"
        :key="index"
      />

      <section class="mt-10" v-if="otherProducts.length > 0">
        <h2>{{ $t("main.otherProducts") }}</h2>
        <others-listing
          v-for="(item, index) in otherProducts"
          :apiData="filterProducts(item)"
          :key="index"
        />
      </section>
    </div>

    <div class="flex flex-col items-center justify-center h-full py-3">
      <div
        class="flex items-center justify-center flex-grow text-3xl font-bold text-center text-gray-300 select-none lg:text-4xl font-eurostile"
      >
        <div v-if="!loader.isLoading && results.length === 0">
          {{ $t("main.selectVehicleFirst") }}
        </div>
      </div>
      <div
        v-if="!loader.isLoading"
        class="flex items-start max-w-screen-lg px-3 text-sm text-gray-600"
      >
        <svg
          class="flex-shrink-0 w-4 h-4 mt-1 mr-2 text-current fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
          />
        </svg>
        <div>{{ $t("main.disclaimer") }}</div>
      </div>
    </div>
  </main>
</template>

<script>
import BaseListing from '@/components/BaseListing.vue';
import OthersListing from '@/components/OthersListing.vue';
import VehicleInfo from '@/components/VehicleInfo.vue';
import HeaderResults from '@/components/HeaderResults.vue';
import Loading from 'vue-loading-overlay';

import 'vue-loading-overlay/dist/vue-loading.css';

import { mapState } from 'vuex';

export default {
  components: {
    BaseListing,
    OthersListing,
    Loading,
    VehicleInfo,
    HeaderResults
  },
  computed: {
    ...mapState({
      results: state => state.apiData.results,
      loader: state => state.loader
    }),
    otherProducts () {
      const resultsArr = Object.values(this.results);
      const otherProducts = resultsArr.slice(1);
      return otherProducts;
    }
  },
  methods: {
    scrollToMain () {
      this.$refs.main.scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
    filterProducts (item, productsType) {
      // Filter out "Spezialprodukte" if there are other results with data from DB
      const newItem = JSON.parse(JSON.stringify(item));
      let products =
        productsType === 'baseProduct'
          ? newItem.products
          : newItem.use[0].products;

      const productsWithoutSpecialProducts = products.filter(
        product => product.fromDB
      );

      if (productsWithoutSpecialProducts.length > 0) {
        products = productsWithoutSpecialProducts;
      }

      if (productsType === 'baseProduct') {
        newItem.products = products;
        return newItem;
      }

      newItem.use[0].products = products;
      return newItem;
    }
  },
  watch: {
    results (arr) {
      if (arr.length > 0) {
        setTimeout(() => {
          this.scrollToMain();
        }, 200);
      }
    }
  }
};
</script>

<style lang="postcss" scoped>
main {
  @apply w-full;
  scroll-margin-top: 24px;
}
.vld-overlay {
  @apply select-none pointer-events-none;
}
</style>
